// extracted by mini-css-extract-plugin
module.exports = {"container":"wordTicker_container__JjPin","blueG":"wordTicker_blueG__9WuB0","greenG":"wordTicker_greenG__1jme_"};